<template>
<div>
  <div v-if="profil.AlanId[0] === 'D'">
    <!--Date-->
    <v-text-field type="date" :label="profil.AlanAdi" v-model="profil.valueDate" hide-details :rules="rulesDate()"> </v-text-field>
  </div>
  <div v-else-if="profil.AlanId[0] === 'S'">
    <!--string-->
    <v-text-field :label="profil.AlanAdi" v-model="profil.value" hide-details :rules="rules()"> </v-text-field>
  </div>
  <div v-else-if="profil.AlanId[0] === 'B'">
    <!--bigint-->
    <v-text-field type=number :label="profil.AlanAdi" v-model="profil.value" hide-details :rules="rules()"> </v-text-field>
  </div>
  <div v-else-if="profil.AlanId[0] === 'M'">
    <v-text-field type=number step=0.0001 :label="profil.AlanAdi" v-model="profil.value" hide-details :rules="rules()"> </v-text-field>
  </div>
  <div v-else>
    <v-text-field :label="profil.AlanAdi" v-model="profil.value" hide-details :rules="rules()"> </v-text-field>
  </div>
  
  
</div>
</template>

<script>
export default {
  props: {
    profil: Object
  },

  data: function () {
    return {
      count: 0
    }
  },
  methods: {
    rules() {

      if (this.profil.Zorunlu == 'E') {
        return [v => !!v || this.$t('Code-cannot-left-blank')]
      } else {
        return []
      }
    },

    rulesDate() {
      if (this.profil.Zorunlu == 'E') {
        return [v => (v != '0001-01-01') || this.$t('Date-cannot-left-blank')]
      } else {
        return []
      }
    },
  }
}
</script>
